import type { Extension } from '@codemirror/state';
import type { SyntaxPalette } from './theme';
import { createTheme } from './theme';

const palette: SyntaxPalette = {
	keyword: '#569cd6',
	controlKeyword: '#c586c0',
	variable: '#9cdcfe',
	type: '#4ec9b0',
	function: '#dcdcaa',
	number: '#b5cea8',
	string: '#ce9178',
	comment: '#6a9955',
	regex: '#d16969',
	modified: '#d7ba7d',
};

export const vsCodeDark: Extension = createTheme(palette, true);

export { applyMergeRevertStyles, mergeRevertStyles } from './utils';
